import store from 'store';
const drag = {
	bind: function (el) {
		let key = 0; //设置一个开关变量
		let x;
		let y;
		let elIsMove = false;
		let startLeft = 0;
		let startTop = 0;
		el.onmousedown = function (evt) {
			key = 1; //开关打开
			var e = evt || window.event;
			startLeft = e.clientX;    //记录初始位置
            startTop = e.clientY;
			x = e.clientX - el.offsetLeft; //鼠标点击的位置距元素边界的距离,用来固定鼠标与元素的相对位置不变
			y = e.clientY - el.offsetTop;

			document.onmouseup = function () {
				document.onmousemove = null;
				document.onmouseup = null;
				key = 0; //开关关闭
			}

			document.onmousemove = function (evt) {
				elIsMove = true;
				var e = evt || window.event;
				if (key == 1) {
					var left = e.clientX - x; //鼠标移动时物体边界距离屏幕边界的距离
					var top = e.clientY - y;
				}
				if (left <= 0) { 
					//左右边界限定
					left = 0;
				} else if (left >= getInner().w - el.offsetWidth) { //元素在最右边时的判定，屏幕的宽度减去元素自身的宽度
					left = getInner().w - el.offsetWidth;
				}
				if (top <= 0) {//上下边界限定
					top = 0;
				} else if (top >= getInner().h - el.offsetHeight){ //元素在最下边时的判定，屏幕的高度减去元素自身的高度
					top = getInner().h - el.offsetHeight;
				}
				el.style.left = left + 'px';
				el.style.top = top + 'px';
				localStorage.setItem('assistant-icon-location-top', `${top}px`);
				localStorage.setItem('assistant-icon-location-left', `${left}px`);
			} 
			//得到浏览器页面内容区窗口的大小
		}
		

		el.onclick = function(evt) {
			var e = evt || window.event;
			if (e.clientX !== startLeft || e.clientY !== startTop) {
				startLeft = 0,
				startTop = 0;
				return;
			}
			store.commit('app/SET_IS_KNOWLEDGE', true);
		}

		
	}
}
export default drag;

function getInner() {
	if (typeof innerHeight == 'undefined') {
		return {
			w: document.documentElement.clientWidth,
			h: document.documentElement.clientHeight
		} //IE浏览器适用
	} else {
		return {
			w: innerWidth,
			h: innerHeight
		} //非IE浏览器适用
	}
}